import { useUser } from "@clerk/clerk-react";

const SUPERADMIN_EMAIL_DOMAIN = "@specstory.com";

/**
 * Whether the signed-in user is SpecStory staff (an `@specstory.com` email).
 *
 * This gates UI only — showing the Admin nav link and rendering the page. The
 * superadmin API endpoints enforce the same check server-side off the JWT email
 * claim, so this is purely cosmetic and never the real security boundary.
 *
 * Returns `false` until Clerk has loaded the user.
 */
export function useIsSuperadmin(): boolean {
  const { user, isLoaded } = useUser();
  if (!isLoaded || !user) return false;
  const email = user.primaryEmailAddress?.emailAddress?.toLowerCase() ?? "";
  return email.endsWith(SUPERADMIN_EMAIL_DOMAIN);
}
